import React from 'react';
import { Route } from 'react-router-dom';
import { localizeRoutePath } from '../../Pages/Helpers/localizeRoutePath';

// ##### Komarov 2025-07-14
const LocalizationRoute = props => {
  const { path, ...rest } = props;

  return <Route path={localizeRoutePath(path)} {...rest} />;
};

// ##### 25-05-21 Komarov
export default LocalizationRoute;
